import React, { useState } from "react";
import { Link } from "react-router-dom";
import portfolio from "./img/porfolio.svg";
import Footer from "./Footer";
import airfryer from "./img/airfryer.png";

function Airfryer() {
  return (
    <div className="flex flex-col w-full min-h-screen overflow-hidden font-sans">
      <nav
        className={
          "sticky flex justify-center align-middle w-full py-3 lg:py-5 mx-auto shadow-xl shadow-gray-100"
        }
      >
        <Link to="/">
          <div className="relative  flex items-center text-lg font-serif font-bold py-2">
            Ana D.
          </div>
        </Link>
      </nav>
      <div className="flex sm:px-4 lg:px-44 md:px-20 px-10 flex-col py-20 h-full w-full overflow-hidden text-left grow">
        <h1 className="text-5xl font-medium text-dark sm:text-5xl md:text-5xl">
          The Elements of Value: Air Fryer
        </h1>
        <p className=" leading-relaxed mb-1 mt-6 font-light text-gray-800  md:text-lg lg:text-lg">
          <b className="font-bold">Description: </b> Great products or services
          target consumer needs under the Elements of Value pyramind. In the
          paper, I discussed how the air fryer targets many consumer needs and
          differentiates itself compared to many other kitchen appliances on the
          market.
        </p>

        <p className=" leading-relaxed mb-6 mt-2 font-light text-gray-800 lg:mb-8 md:text-lg lg:text-lg">
          <b className="font-bold">Role: </b> Product researcher
        </p>

        <p className=" leading-relaxed mb-6 mt-2 font-light text-gray-800 lg:mb-8 md:text-lg lg:text-lg">
          <b className="font-bold">Pdf Link: </b>{" "}
          <a
            className="text-blue-600"
            target="_blank"
            href="/img/anawritingsample.pdf"
          >
            Writing Sample
          </a>
        </p>

        <img src={airfryer} alt="header image" className="w-full mb-10" />

        <hr></hr>

        <p className=" leading-relaxed mb-1 mt-6 font-light text-gray-800  md:text-lg lg:text-lg">
          In my Sales and Customer Relations course, we had to analyze a product
          or service and connect it to The Elements of Value Pyramid. The
          Element of Value Pyramid shows the consumer needs a product or service
          should target. The four needs consist of functional, emotional, life
          changing, and social impact elements. A great product or service will
          target many areas under these consumer needs since it is correlated to
          customer loyalty and the company’s longevity. In the paper, I
          discussed how the air fryer targets many consumer needs and
          differentiates itself compared to many other kitchen appliances on the
          market.
        </p>

        <div className="grid max-w-screen-lg px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
            <div className="relative inline-flex overflow-hidden w-80 h-100">
              <img
                src={portfolio}
                alt="Ana Diaz-Ramos"
                className="self-center drop-shadow-2xl object-cover"
              />
            </div>
          </div>
          <div className="mr-auto place-self-center mt-10 lg:col-span-7">
            <h1 className="text-5xl font-display font-medium tracking-tight text-dark sm:text-5xl md:text-5xl">
              Ana Diaz-Ramos
            </h1>
            <p className="max-w-2xl leading-relaxed mb-6 mt-2 font-light text-gray-800 lg:mb-8 md:text-lg lg:text-lg">
              A passionate marketer with the goal to help bring products and
              services to those in need and drive business impact.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Airfryer;
